import React from 'react';

interface WheelIconProps {
  className?: string;
  size?: number;
  filled?: boolean;
}

/**
 * Brand mark — a stylised wheel of prizes split into 8 segments
 * with a pointer at the top. Used wherever a generic "Sparkles"-type
 * icon would feel off-brand (KPIs, "Nova Roda" actions, etc.).
 */
const WheelIcon: React.FC<WheelIconProps> = ({ className = '', size, filled = false }) => {
  const sizeProps = size ? { width: size, height: size } : {};
  return (
    <svg
      {...sizeProps}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <circle cx="12" cy="12" r="9" />
      <line x1="12" y1="3" x2="12" y2="21" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="5.64" y1="5.64" x2="18.36" y2="18.36" />
      <line x1="18.36" y1="5.64" x2="5.64" y2="18.36" />
      <circle cx="12" cy="12" r="2" fill={filled ? 'currentColor' : 'none'} />
      <polygon points="11,1 13,1 12,3.6" fill="currentColor" stroke="none" />
    </svg>
  );
};

export default WheelIcon;
